// DS: PO28
/** Popup prompting users to verify their email address */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useContext, useCallback } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { FirstTimeFlag } from '../redux/firstTimeFlags';
import VerificationPopupDesktop from './VerificationPopupDesktop';
import VerificationPopupMobile from './VerificationPopupMobile';
export const VerificationPopup = (_param)=>{
    var { dropFlagOnClose, dropFirstTimeFlag, onClose } = _param, props = _object_without_properties(_param, [
        "dropFlagOnClose",
        "dropFirstTimeFlag",
        "onClose"
    ]);
    const isMobile = useContext(MobileContext);
    const handleClose = useCallback(()=>{
        if (dropFlagOnClose) {
            dropFirstTimeFlag({
                flag: FirstTimeFlag.WelcomePopupNotClosed
            });
        }
        return onClose && onClose();
    }, [
        dropFlagOnClose,
        dropFirstTimeFlag,
        onClose
    ]);
    return isMobile ? /*#__PURE__*/ React.createElement(VerificationPopupMobile, _object_spread({
        onClose: handleClose
    }, props)) : /*#__PURE__*/ React.createElement(VerificationPopupDesktop, _object_spread({
        onClose: handleClose
    }, props));
};
VerificationPopup.displayName = 'VerificationPopup';
export default VerificationPopup;

//# sourceMappingURL=VerificationPopup.js.map